import { styled } from 'styled-components';
import { dontForwardProps } from '../../../util';
export const TextFieldLabelAndInputWrapper = styled.div.withConfig(dontForwardProps()).withConfig({
  displayName: "TextFieldLabelAndInputWrapper",
  componentId: "asurion-ui-react__sc-1cbkv0x-0"
})(["position:relative;flex-grow:1;cursor:inherit;"]);